/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PenIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PenIcon({
  children,
  viewPath = "/DesignSystem/Svgs/PenIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 30,
  height = 30,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="PenIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 30 30"
 style={{'--as-1-19R4rM': alignSelf,'--mt-2-19R4rM': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-19R4rM': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-19R4rM': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-19R4rM': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-19R4rM': opacity,'--w-10-19R4rM': typeof width === 'number' ? `${width}px` : width,'--h-11-19R4rM': typeof height === 'number' ? `${height}px` : height,'--a-7-19R4rM': isAnimated ? animation : "none",'--sd-8-19R4rM': isAnimated ? strokeDashoffset : 0,'--sd-9-19R4rM': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="PenIcon.SvgPath"
  data-view-path={viewPath}
 d="M22.828 3c-.512 0-1.023.195-1.414.586L19 6l5 5 2.414-2.414a2 2 0 000-2.828l-2.172-2.172A1.994 1.994 0 0022.828 3zM17 8L5.26 19.74s.918-.082 1.26.26c.342.342.06 2.58.48 3 .42.42 2.644.124 2.963.443.319.32.297 1.297.297 1.297L22 13l-5-5zM4 23l-.943 2.672A1 1 0 003 26a1 1 0 001 1 1 1 0 00.328-.057 1 1 0 00.01-.004l.025-.007a1 1 0 00.006-.004L7 26l-1.5-1.5L4 23z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}